import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';
import maybeRender from 'app/common/components/maybeRender';
import { currentUrl } from 'app/common/utils/RouterSelectors';

// This component watches for changes in the current URL and fires an account
// limits reload whenever they occur.
const UrlBasedAccountLimitReloader = createReactClass({
  displayName: 'UrlBasedAccountLimitReloader',

  componentDidMount() {
    const throttleIntervalMilliseconds = 10 * 1000;
    this.throttledReloadFunction = _.throttle(
      this.doReloadAccountLimits,
      throttleIntervalMilliseconds
    );
  },

  componentDidUpdate() {
    this.throttledReloadFunction();
  },

  doReloadAccountLimits() {
    this.props.reloadAccountLimits();
  },

  render() {
    // This is a no-UI component, so there's no need to actually render anything.
    return null;
  },
});

const mapStateToProps = state => {
  const url = currentUrl(state);
  const isInEditor = url.startsWith('/app/editor');
  return {
    shouldRender: Profile.selectors.all.isLoggedIn(state) && !isInEditor,
    url,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reloadAccountLimits() {
      dispatch(Account.actions.reloadCurrentAccount());
    },
  };
};

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  maybeRender(props => props.shouldRender)
)(UrlBasedAccountLimitReloader);
